import { useState } from 'react'
import { PhoneValidationData } from '../pages/home/utils/phoneValidation'
import { api } from '../services/api'

export function useValidatePhone() {
    const [success, setSuccess] = useState(false)
    const [message, setMessage] = useState('')
    const [statusCode, setStatusCode] = useState(0)
    
    async function validatePhone(data: PhoneValidationData) {
        try {
            const resp = await api.post('/deezer/confirmar', {
                subscriberId: data.phone,
                IdCliente: data.IdCliente,
                Codigo: data.Codigo,
            }, {
                headers: {
                    'Authorization': `Basic ${process.env.REACT_APP_AUTHORIZATION_BASIC}`,
                    'Content-Type': 'application/json'
                }
            });
            setSuccess(resp.data.success)
            setMessage(resp.data.message)
            setStatusCode(resp.status)
        } catch (error: any) {
            setSuccess(error.response.data.success)
            setMessage(error.response.data.message)
            setStatusCode(error.response.status)
        }
    }

    return {
        validatePhone,
        success,
        message,
        statusCode
    }
}